<template>
    <div id="modal-company-select" class="modal fade" data-backdrop="static" data-keyboard="false">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-body pb-2">

                    <input v-model.trim="keyword" type="text" class="form-control mb-2" maxlength="100" spellcheck=false placeholder="会社名・グループ名"> </input>

                    <!-- 抽出リスト -->
                    <ul v-show="keyword" class="list-group list-group-cust overflow-auto">
                        <li v-for="(item, idx) in selectList" :key="idx" class="list-group-item px-2 py-1" @click="selectDo(item)">
                            <small>
                                <span class="text-truncate flex-fill">{{item.user_group}}</span>
                                <div>{{item.name}}</div>
                            </small>
                        </li>
                        <li v-show="hasNoSearchData" class="list-group-item text-center text-muted">該当するデータがありません</li>
                    </ul>

                    <!-- すべて -->
                    <ul v-show="showAll" class="list-group list-group-cust overflow-auto">
                        <template v-if="selectedCmp">
                            <li class="list-group-item px-2 py-1 bg-light" >前回選択</li>
                            <li class="list-group-item px-2 py-1" @click="selectDo(selectedCmp)">
                                <small>
                                    <span class="text-truncate flex-fill">{{selectedCmp.user_group}}</span>
                                    <div>{{selectedCmp.name}}</div>
                                </small>
                            </li>
                        </template>
                        <li class="list-group-item px-2 py-1 bg-light" >すべて</li>
                        <template v-if="salesOpt">
                            <li class="list-group-item px-2 py-1" @click="selectDo(salesOptObj)">
                                <small>
                                    <span class="text-truncate flex-fill">{{salesOptObj.user_group}}</span>
                                    <div>{{salesOptObj.name}}</div>
                                </small>
                            </li>
                        </template>
                        <template v-if="teOpt">
                            <li class="list-group-item px-2 py-1" @click="selectDo(teOptObj)">
                                <small>
                                    <span class="text-truncate flex-fill">{{teOptObj.user_group}}</span>
                                    <div>{{teOptObj.name}}</div>
                                </small>
                            </li>
                        </template>
                        <template v-if="pjOpt">
                            <li class="list-group-item px-2 py-1" @click="selectDo(pjOptObj)">
                                <small>
                                    <span class="text-truncate flex-fill">{{pjOptObj.user_group}}</span>
                                    <div>{{pjOptObj.name}}</div>
                                </small>
                            </li>
                        </template>
                        <li v-for="(item, idx) in list" :key="idx" class="list-group-item px-2 py-1" @click="selectDo(item)">
                            <small>
                                <span class="text-truncate flex-fill">{{item.user_group}}</span>
                                <div>{{item.name}}</div>
                            </small>
                        </li>
                    </ul>

                </div>
                <div class="modal-footer">
                    <div class="container">
                        <div class="row justify-content-center">
                            <div class="col-12 col-md-6">
                                <button class="btn btn-primary btn-block m-0" type="button" @click="closeThis">
                                    閉じる
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            list: Array,
        },
        data () {
            return {
                showAll: true,
                keyword: '',
                selectList: [],
                time: null,
                selectedCmp: null,
                name: null,
                salesOpt: false,
                salesOptObj: {
                    user_group: 'none',
                    name:'個人営業'
                },
                teOpt: false,
                teOptObj: {
                    user_group: 'none',
                    name:'Promeraia(自社)'
                },
                pjOpt: false,
                pjOptObj: {
                    user_group: 'system',
                    name:'Promeraia(自社)'
                }
            }
        },
        watch: {
            keyword () {
                if (!this.keyword) {
                    this.selectList = []
                    this.showAllList()
                    return
                }

                this.hideAllList()

                if (this.timer) {
                    clearTimeout(this.timer)
                }

                this.timer = setTimeout(()=> {
                    let result = []
                    result = this.list.filter((item)=>
                           String(item.name).toLowerCase().indexOf(this.keyword.toLowerCase()) != -1
                        || String(item.user_group).toLowerCase().indexOf(this.keyword.toLowerCase()) != -1
                    )
                    this.selectList = result

                }, 100)
            }
        },
        computed: {
            hasNoSearchData () {
                return !this.selectList.length
            },
        },
        methods: {
            showAllList () {
                this.showAll = true
            },
            hideAllList () {
                this.showAll = false
            },
            selectDo (val) {
                let method = this.name ? this.name + "CompanySet" : "setCompany" 
                this.saveCmpToLocal(val)
                this.$parent[method](val)
                this.closeThis()
            },
            saveCmpToLocal (val) {
                try {
                    let key = this.name ? this.name + "comModalCompany" : "comModalCompany"
                    sessionStorage.setItem(key, JSON.stringify(val))
                } catch (e) {}
            },
            getCmpFromLocal () {
                let cmp = null
                try {
                    let key = this.name ? this.name + "comModalCompany" : "comModalCompany"
                    if (sessionStorage.getItem(key)) {
                        cmp = JSON.parse(sessionStorage.getItem(key))
                    }
                } catch (e){}
                return cmp
            },
            openThis (opt = null) {
                if (opt) {
                    this.name = opt.name ? opt.name : null
                    this.salesOpt = opt.salesOpt ? opt.salesOpt : false
                    this.teOpt = opt.teOpt ? opt.teOpt : false
                    this.pjOpt = opt.pjOpt ? opt.pjOpt : false
                }
                this.selectedCmp = this.getCmpFromLocal()
                $('#modal-company-select').modal('show')
            },
            closeThis () {
                this.resetThis()
                $('#modal-company-select').modal('hide')
            },
            resetThis () {
                this.showAll =  true
                this.keyword = ''
                this.selectList = []
                this.time = null
                this.selectedCmp = null
                this.name = null
                this.salesOpt = false
                this.teOpt = false
                this.pjOpt = false
            }
        },
    }
</script>

<style lang="stylus">
    .list-group-cust
        height: 302px;
</style>
